import { ReactNode } from "react"

interface TabbarProps {
  children: ReactNode
}
const Tabbar = ({ children }: TabbarProps) => {
  return (
    <nav>
      <style jsx>{`
        .tabList {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
          list-style: none;
          padding: 0;
          width: 100%;
        }
        .tabList::after {
          content: "";
          flex: 1 1 66%;
          height: 0;
        }
      `}</style>
      <ul className="tabList">{children}</ul>
    </nav>
  )
}

export default Tabbar
